import { render, staticRenderFns } from "./StudentProfileNotifications.vue?vue&type=template&id=4cc7b2cf&scoped=true&"
import script from "./StudentProfileNotifications.vue?vue&type=script&lang=js&"
export * from "./StudentProfileNotifications.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileNotifications.vue?vue&type=style&index=0&id=4cc7b2cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7b2cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VIcon})
